import { useCallback, useEffect } from 'react';

import { type BaseAIAction } from '@atlassian/ai-smart-button-api';

import { useConversationActionsStoreActions } from '@confluence/conversation-assistant';

import {
	useConfluenceRovoButtonActions,
	useConfluenceRovoButtonEditorActions,
	useConfluenceRovoButtonConsumptionActions,
} from '../ConfluenceRovoButtonStore';
import { mapActionsToConversationActions } from '../utils/mapToConversationActions';

export const useAIActions = () => {
	const { setConversationActions } = useConversationActionsStoreActions();
	const { setEditorActions: setEditorActionsInStore, setConsumptionActions } =
		useConfluenceRovoButtonActions();
	const editorActions = useConfluenceRovoButtonEditorActions();
	const consumptionActions = useConfluenceRovoButtonConsumptionActions();

	const setEditorActions = useCallback(
		(actions: BaseAIAction[]) => {
			setEditorActionsInStore(mapActionsToConversationActions(actions));
		},
		[setEditorActionsInStore],
	);

	useEffect(() => {
		setConversationActions([...editorActions, ...consumptionActions]);
	}, [consumptionActions, editorActions, setConversationActions]);

	return {
		setEditorActions,
		setConsumptionActions,
	};
};
